<template>
  <div class="TkIntelPolicy">
    <ld-header>{{ $t('A019','国际特惠') }}</ld-header>

    <mescroll-vue
      ref="mescroll"
      :down="{}"
    >
      <div class="wrapper pad8">
        <div
          class="policy-item"
          v-for="policy in policyList"
          :key="policy.id"
          @click="detail(policy.id)"
        >
          <h3 class="policy-title">
            {{ policy.title }}
          </h3>
          <div class="policy-banner">
            <img :src="policy.coverPic">
          </div>
          <p class="policy-description">
            {{ policy.description }}
          </p>
          <span class="font12">发布 <time>{{ policy.fbsj }}</time></span>
        </div>
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
export default {
  name: 'TkIntelPolicy',
  components: {
    MescrollVue: () => import('mescroll.js/mescroll.vue')
  },
  data () {
    return {
      policyList: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    async getList() {
      const { data = [] } = await this.$api['common/policyList']()
      this.policyList = data
    },
    detail (id) {
      this.$router.push(`/tkIntel/policy/detail/${id}`)
    }
  }
}
</script>

<style lang="less">
.TkIntelPolicy {
  h3 {
    margin: 0;
  }

  .wrapper {
    height: calc(100vh - 50px);
  }

  .pad8 {
    padding: 8px;
  }

  .policy-item {
    margin-top: 10px;
    padding: 10px 20px;
    background-color: @color-background-white;
    border-radius: @border-radius-sm;

    .policy-banner {
      position: relative;
      overflow: hidden;
      height: 200px;
      margin-top: 5px;

      img {
        width: 100%;
        min-height: 117px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
      }
    }

    .policy-description {
      margin: 5px 0;
    }
  }

}
</style>